export default "__VITE_ASSET__CU51iBOh__"